import type { Font } from './font';

export interface SvgFile {
    id: number;
    file: string;
    organization: number;
    width: number;
    height: number;
    availableFonts: Font[];
}
